module.exports = __webpack_public_path__ + "cf6613d1adf490972c557a8e318e0868.woff";